
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

// Definición de defaults

export const defaultPlantillaDetalle: PlantillaDetalleProps = {
    idPlantilla: 0,
    descripcion: '',
    contenido: '',
}

export const defaultPlantilla: PlantillaResponse = {
    ...defaultHttpResponse,
}

// Creación de interfaces

export interface PlantillaProps {
    idPlantilla:            number;
    descripcion:            string;
    contenido:              string;
    idAutoridad:            number;
    activo:                 boolean;
    idTipoAcuerdo?:         number;
    idSubTipoAcuerdo?:      number;
    idTipoNotificacion?:    number;
}

export interface PlantillaAdminProps {
    idPlantilla:            number;
    descripcion:            string;
    contenido:              string;
    activo:                 boolean;
    idAutoridad:            number;
    idTipoAcuerdo?:         number;
    idSubTipoAcuerdo?:      number;
    idTipoNotificacion?:    number;
}

export interface PlantillaResponse extends HttpResponse {
    plantilla?:             PlantillaProps;
}

export interface ObtenerPlantillasAdminParams {
    idAutoridad:           number;    
    idTipoAcuerdo:         number;
    idSubTipoAcuerdo:      number;
    idTipoNotificacion:    number;
}

export interface ObtenerPlantillasParams {
    idAutoridad:           number;    
    idTipoAcuerdo:         number;
    idSubTipoAcuerdo:      number;
    idTipoNotificacion:    number;
}

export interface PlantillaDetalleProps {
    idPlantilla:            number;
    descripcion:            string;
    contenido:              string;
}
